import React from "react";
import {classNames} from "../../../utils";

export const ToolbarIcon: React.FC<any> = ({
                                               Icon,
                                               size = "text-2xl",
                                               className,
                                               active = false,
                                               height = "h-10",
                                               activeColor = "fill-riders-green-dark dark:fill-riders-green",
                                               activeBorderColor = "border-vs-light-input dark:border-vs-dark-input",
                                               alert = 0,
                                               onClick: handler,
                                               label
                                           }) => {
    return (
        <span
            className={classNames(active ? `bg-[#C6FFE5] rounded-r-xl ${activeColor}` : 'hover:bg-[#78E4B6] transition-all', height, 'py-3 pl-5 w-full dark:my-0 cursor-pointer flex items-center relative rounded-r-xl', className)}
            onClick={handler}
        >
      <Icon
          className={`${
              active
                  ? `${activeColor}`
                  : "fill-white"
          } ${size}`}
          fill={
              active
                  ? `${activeColor}`
                  : "fill-arduino-green-dark dark:fill-vs-dark-disabled"
          }
      />
            {label && <p className='ml-3 leading-tight'>{label}</p>}
            {alert > 0 && (
                <span className="absolute bottom-1.5 right-1.5 text-2xs bg-riders-green rounded-full px-1">
          {alert}
        </span>
            )}
    </span>
    );
};
